import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { getDensityModeString } from 'owa-fabric-theme';

import styles from './ShimmerRowThreeCol.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface ShimmerRowThreeColProps {
    isFirstMessage: boolean;
}

const ShimmerRowThreeCol = observer(function ShimmerRowThreeCol(props: ShimmerRowThreeColProps) {
    const densityModeString = getDensityModeString();

    const shimmerWithElementFirstRow = [
        { type: ShimmerElementType.gap, width: '12%' },
        { type: ShimmerElementType.line, width: '24%' },
        { type: ShimmerElementType.gap, width: '64%' },
    ];

    const generateSecondRow = (): JSX.Element => {
        return (
            <div className={styles.shimmerSecondRow}>
                <div className={styles.personaCircle}>
                    <ShimmerElementsGroup
                        width={'100%'}
                        shimmerElements={[
                            { type: ShimmerElementType.gap, width: '16px', height: 28 },
                            densityModeString === 'full'
                                ? { type: ShimmerElementType.circle, height: 28 }
                                : { type: ShimmerElementType.gap, width: '28px', height: 28 },
                            { type: ShimmerElementType.gap, width: '100%', height: 28 },
                        ]}
                    />
                </div>
                <div className={styles.secondRowText}>
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: '66%' },
                            { type: ShimmerElementType.gap, width: '36%', height: 28 },
                            { type: ShimmerElementType.line, width: '10%' },
                            { type: ShimmerElementType.gap, width: '4%', height: 28 },
                        ]}
                    />
                </div>
            </div>
        );
    };
    const shimmerWithElementThirdRow = [
        { type: ShimmerElementType.gap, width: '12%' },
        { type: ShimmerElementType.line, width: '50%' },
        { type: ShimmerElementType.gap, width: '38%' },
    ];

    return (
        <div
            className={classNames(
                densityModeString,
                props.isFirstMessage ? styles.paddingFirstMessage : styles.paddingMessage,
                styles.mailListShimmerContainer
            )}>
            <Shimmer shimmerElements={shimmerWithElementFirstRow} />
            <Shimmer customElementsGroup={generateSecondRow()} />
            <Shimmer shimmerElements={shimmerWithElementThirdRow} />
        </div>
    );
});
export default ShimmerRowThreeCol;
